import useGetProductsNumber from './useGetProductsNumber'

export default useGetProductsNumber
